import { useState } from "react";
import { CHAVE_TOKEN } from "../../../utils/formata";

// Página de resgate: lê as respostas da API que o NAVEGADOR guardou em cache
// (o "pisca" dos dados quando o servidor está fora) e entrega um arquivo .json
// com tudo — sem depender do banco. Criada no incidente do Neon (27/08/2026).
const ROTAS = [
    { rota: "/emprestimo", chave: "emprestimos", rotulo: "Empréstimos (com parcelas)" },
    { rota: "/empresa", chave: "empresas", rotulo: "Clientes / Empresas" },
    { rota: "/parcela/abertas", chave: "parcelas", rotulo: "Parcelas em aberto" },
    { rota: "/dashboard", chave: null, rotulo: "Dashboard" },
    { rota: "/movimentacao", chave: null, rotulo: "Caixa (movimentações)" },
    { rota: "/proposta", chave: "propostas", rotulo: "Propostas" },
    { rota: "/documento", chave: "documentos", rotulo: "Documentos (lista)" },
    { rota: "/usuario", chave: "usuarios", rotulo: "Equipe" },
    { rota: "/visita/solicitacoes", chave: "solicitacoes", rotulo: "Visitas solicitadas" },
    { rota: "/emprestimo/agenda/visitas", chave: "visitas", rotulo: "Agenda de visitas" },
];

const base = window.location.hostname === "localhost" ? "http://localhost:5000" : "/api";

async function lerDoCache(rota) {
    const token = localStorage.getItem(CHAVE_TOKEN) || "";
    const headers = { Authorization: `Bearer ${token}` };
    // 1) só cache (mesma origem) — nunca bate no servidor
    try {
        const r = await fetch(base + rota, { headers, cache: "only-if-cached", mode: "same-origin" });
        if (r.ok) return { origem: "cache", dados: await r.json(), data: r.headers.get("date") };
    } catch (e) { /* only-if-cached sem entrada lança erro — segue */ }
    // 2) cache mesmo vencido; se não houver, tenta o servidor
    try {
        const r = await fetch(base + rota, { headers, cache: "force-cache" });
        if (r.ok) return { origem: r.headers.get("cf-ray") ? "servidor" : "cache", dados: await r.json(), data: r.headers.get("date") };
        return { origem: "erro", status: r.status };
    } catch (e) {
        return { origem: "erro", status: String(e.message || e) };
    }
}

function contar(res, chave) {
    if (!res?.dados) return 0;
    if (chave && Array.isArray(res.dados[chave])) return res.dados[chave].length;
    if (Array.isArray(res.dados)) return res.dados.length;
    return Object.keys(res.dados).length;
}

export default function Resgate() {
    const [linhas, setLinhas] = useState([]);
    const [pacote, setPacote] = useState(null);
    const [rodando, setRodando] = useState(false);
    const [copiado, setCopiado] = useState(false);

    async function resgatar() {
        setRodando(true);
        const resultado = {};
        const saida = [];
        for (const r of ROTAS) {
            const res = await lerDoCache(r.rota);
            const n = contar(res, r.chave);
            saida.push({ ...r, origem: res.origem, n, status: res.status, data: res.data });
            if (res.dados) resultado[r.rota] = res.dados;
            setLinhas([...saida]);
        }
        setPacote({
            geradoEm: new Date().toISOString(),
            aparelho: navigator.userAgent,
            usuarioToken: (localStorage.getItem(CHAVE_TOKEN) || "").slice(0, 12) + "…",
            dados: resultado,
        });
        setRodando(false);
    }

    const texto = pacote ? JSON.stringify(pacote) : "";
    const nomeArquivo = `resgate-help-${new Date().toISOString().slice(0, 16).replace(/[:T]/g, "-")}.json`;

    function baixar() {
        const blob = new Blob([texto], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = nomeArquivo; a.click();
        setTimeout(() => URL.revokeObjectURL(url), 2000);
    }

    async function compartilhar() {
        try {
            const file = new File([texto], nomeArquivo, { type: "application/json" });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({ files: [file], title: "Resgate Help" });
                return;
            }
        } catch (e) { /* cancelado */ }
        baixar();
    }

    async function copiar() {
        try { await navigator.clipboard.writeText(texto); setCopiado(true); setTimeout(() => setCopiado(false), 2500); } catch { }
    }

    const totalRegistros = linhas.reduce((s, l) => s + (l.n || 0), 0);

    return (
        <div className="pagina">
            <h2 className="he-titulo">Resgate de <span className="he-dourado">dados</span></h2>
            <p style={{ color: "#9aa5b5", fontSize: "0.9em" }}>
                Lê o que este aparelho guardou do painel (cache do navegador) e gera um arquivo com tudo. Use no mesmo aparelho e navegador em que você usa o painel.
            </p>

            {!pacote &&
                <button className="btn btn-he" style={{ width: "100%", minHeight: 52 }} onClick={resgatar} disabled={rodando}>
                    {rodando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-life-preserver"></i> Resgatar dados deste aparelho</>}
                </button>
            }

            {linhas.length > 0 &&
                <div className="he-card" style={{ margin: "1em 0" }}>
                    {linhas.map((l) => (
                        <div key={l.rota} style={{ display: "flex", justifyContent: "space-between", gap: 10, padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,0.06)", fontSize: "0.9em" }}>
                            <span>{l.rotulo}</span>
                            <span style={{ color: l.n > 0 ? "#2ecc71" : "#ff6b5b", fontWeight: 700, whiteSpace: "nowrap" }}>
                                {l.n > 0 ? `${l.n} registro(s)` : l.origem === "erro" ? `sem cache (${l.status})` : "vazio"}
                            </span>
                        </div>
                    ))}
                    <div style={{ marginTop: 10, fontWeight: 700, color: totalRegistros > 0 ? "#2ecc71" : "#ff6b5b" }}>
                        {totalRegistros > 0 ? `✅ ${totalRegistros} registros encontrados neste aparelho` : "Nenhum dado em cache neste aparelho"}
                    </div>
                </div>
            }

            {pacote && totalRegistros > 0 &&
                <div className="acoes-linha uma-coluna">
                    <button className="btn btn-he" onClick={compartilhar}><i className="bi bi-send"></i> Enviar arquivo (WhatsApp / e-mail)</button>
                    <button className="btn btn-outline-he" onClick={baixar}><i className="bi bi-download"></i> Baixar arquivo .json</button>
                    <button className="btn btn-outline-he" onClick={copiar}><i className="bi bi-clipboard"></i> {copiado ? "Copiado!" : "Copiar tudo"}</button>
                </div>
            }
            {pacote && totalRegistros === 0 &&
                <p style={{ color: "#9aa5b5", fontSize: "0.85em" }}>Dica: abra o painel normalmente neste aparelho (Empréstimos, Empresas, Caixa) — se os dados "piscarem", volte aqui e tente de novo.</p>
            }
        </div>
    );
}
